export const useUserId = () => {
	const userIdRaw = sessionStorage.getItem('id');
	if (!userIdRaw) {
		return undefined;
	}

	const userId = parseInt(userIdRaw);
	if (Number.isNaN(userId)) {
		return undefined;
	}

	return userId;
};
